/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

export class PlatformProvider {
  static displayName = 'PlatformProvider';
  private static instance: PlatformProvider;
  private platform: any;
  private constructor() {
    this.platform = require('platform');
  }

  public static getInstance(): PlatformProvider {
    if (!PlatformProvider.instance) {
      PlatformProvider.instance = new PlatformProvider();
    }

    return PlatformProvider.instance;
  }

  getPlatform() {
    const {
      name,
      version,
      layout,
      os,
      description,
      product,
      manufacturer,
      ua,
    } = this.platform;
    return {
      'x-vlinder-D-name': name,
      'x-vlinder-D-version': version,
      'x-vlinder-D-layout': layout,
      'x-vlinder-D-os': os,
      'x-vlinder-D-description': description,
      'x-vlinder-D-product': product,
      'x-vlinder-D-manufacturer': manufacturer,
      'x-vlinder-D-ua': ua,
    };
  }
}
